import { render, staticRenderFns } from "./NewFeedDialog.vue?vue&type=template&id=f74c149c&scoped=true&"
import script from "./NewFeedDialog.vue?vue&type=script&lang=js&"
export * from "./NewFeedDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewFeedDialog.vue?vue&type=style&index=0&id=f74c149c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74c149c",
  null
  
)

export default component.exports